import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { EmployeeService } from '../../services/employee/employee.service'
import { catchError, mergeMap, of } from 'rxjs'
import { show_error_action, show_success_msg_after_updation_action } from '../action/common/common.action'
import {
  fetch_employee_personal_info,
  fetch_employee_personal_info_success,
  fetch_employee_with_reference_details,
  fetch_employee_with_reference_details_success,
  update_employee_personal_info_action,
  update_employee_personal_info_success_action
} from '../action/employee.action'
import { update_user_mobile_number } from '../action/initialize.action'

@Injectable()
export class EmployeeEffects {
  constructor(private actions$: Actions, private employeeService: EmployeeService) {}

  fetch_employee_personal_info$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_employee_personal_info),
      mergeMap((action) =>
        this.employeeService.getEmployeePersonalInfoData().pipe(
          mergeMap((response) => [fetch_employee_personal_info_success(response)]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_employee_personal_info_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(update_employee_personal_info_action),
      mergeMap((employee) =>
        this.employeeService.callUpdateApi(employee).pipe(
          mergeMap((employee) => [
            update_employee_personal_info_success_action(employee),
            show_success_msg_after_updation_action({ moduleName: 'Profile' }),
            update_user_mobile_number({ mobileNumber: employee?.mobileNumber })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  fetch_employee_with_reference_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_employee_with_reference_details),
      mergeMap((action) =>
        this.employeeService.getEmployeeWithReferenceDetails().pipe(
          mergeMap((response) => [fetch_employee_with_reference_details_success(response)]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
